import * as React from "react";
import { forwardRef } from "react";
const SvgCustomArrowLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 16L9.41 14.59L3.83 9L16 9V7L3.83 7L9.41 1.41L8 1.90735e-06L1.90735e-06 8L8 16Z", fill: "#62676E" }));
const ForwardRef = forwardRef(SvgCustomArrowLeft);
export default ForwardRef;
